import { CustomConnectionURL, persistURLService } from '../services/connectionString.service';

import type {
  ConnectSubscriptionStatus,
  ProvisioningStatus,
  Subscription,
  SubscriptionConnection,
  Subscriptions,
} from '../types/subscription.types';

const ProvisioningStatusMapTable: Record<ProvisioningStatus, ConnectSubscriptionStatus> = {
  provisioning: 'provisioning',
  pending: 'provisioning',
  failed: 'failed',
  destroyed: 'destroyed',
  completed: 'poll_until_connect',
  hibernated: 'hibernated',
  trying_to_connect: 'trying_to_connect',
  checking_connection: 'trying_to_connect',
};

/*
 * This utility function calculates the status of a subscription based on its provisioning status.
 * It returns a string representing the current status of the subscription.
 */
export const calculateSubscriptionProvisioningStatus = (
  provisioningStatus: ProvisioningStatus,
  isHibernated: boolean
): ConnectSubscriptionStatus => {
  if (isHibernated === true) {
    return 'hibernated';
  }

  const status = ProvisioningStatusMapTable[provisioningStatus];

  return status ? status : 'failed';
};

export const shouldSkipProvisioning = (subscription: Subscription) => {
  const provisionerVersion = subscription?.provisioner_version;

  return (
    (subscription?.service === 'on-premise' ||
      (provisionerVersion && !provisionerVersion.startsWith('2'))) ??
    false
  );
};

export const getConnectionStringFn =
  (persistedURLs?: CustomConnectionURL) => (subscriptionId: string) => {
    const customConnectionURL = persistedURLs?.[subscriptionId];

    return customConnectionURL ? customConnectionURL : undefined;
  };

export const getConnectionString = getConnectionStringFn(persistURLService().getAllPersistedURLs());

export const findDefaultUrl = (subscription?: Subscription) => {
  if (subscription?.connections) {
    const defaultConnection = subscription.connections.find(
      (subConnection: SubscriptionConnection) => subConnection.id === 'default'
    );

    return defaultConnection?.url;
  }
};

export const findSubscription = (state: Subscriptions) => (id: string) =>
  state.find((s) => s.id === id);
